import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Children, PureComponent, cloneElement } from 'react';
import classnames from 'classnames';
import { buttonClass } from './styles';
import { isRTL } from '../config';

var ButtonGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ButtonGroup, _PureComponent);

  var _super = _createSuper2(ButtonGroup);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _super.apply(this, arguments);
  }

  _createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          outline = _this$props.outline,
          size = _this$props.size,
          type = _this$props.type,
          style = _this$props.style;
      var typeSetted = type !== 'default';
      var className = classnames(buttonClass('group', (outline || !typeSetted) && 'outline', isRTL() && 'group-rtl'), this.props.className);
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: style
        }, Children.toArray(children).map(function (child) {
          return (
            /*#__PURE__*/
            cloneElement(child, {
              size: size,
              outline: outline,
              type: typeSetted ? type : child.props.type
            })
          );
        }))
      );
    }
  }]);

  return ButtonGroup;
}(PureComponent);

ButtonGroup.defaultProps = {
  outline: false,
  type: 'default'
};
export default ButtonGroup;